import axios from 'axios'
import { API_URL } from '../../../../../../constants'
import { REQUISITE_AUDIT_API_URL, EMPLOYEE_LOOKUP_API_URL } from './consts'
import { RequisiteAuditQuery } from './query.types'
import { IEmployeeLookupItem, IRequisiteAuditItem } from './response.types'
import { ApiResponse } from '../../../../../common/api/response.types'

export const getRequisiteAudit = (query: RequisiteAuditQuery) =>
  axios.get<ApiResponse<IRequisiteAuditItem[]>>(`${API_URL}/${REQUISITE_AUDIT_API_URL}`, { params: query })

export const getEmployeeLookup = () =>
  axios.get<ApiResponse<IEmployeeLookupItem[]>>(`${API_URL}/${EMPLOYEE_LOOKUP_API_URL}`)
